import { StyleSheet } from 'react-native';
import { FontFamily } from '../../../../../constants/fonts';

const executiveStyles = StyleSheet.create({
  maxPotentialToggleWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 10,
    gap: 10,
  },
  maxPotentialExecHeader: {
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },
  maxPotentialExecTitleWrap: {
    flex: 1,
    minWidth: 0,
  },
  maxPotentialToggleStack: {
    alignItems: 'flex-end',
    gap: 6,
  },
  maxPotentialToggleGroup: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#CBD5E1',
    borderRadius: 8,
    overflow: 'hidden',
  },
  maxPotentialToggleBtn: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    backgroundColor: '#FFFFFF',
  },
  maxPotentialToggleBtnActive: {
    backgroundColor: '#005CBC',
  },
  maxPotentialToggleBtnText: {
    fontSize: 12,
    color: '#4B5563',
    fontFamily: FontFamily.bold,
  },
  maxPotentialToggleBtnTextActive: {
    color: '#FFFFFF',
  },
  maxPotentialToggleHint: {
    fontSize: 12,
    color: '#005CBC',
    fontFamily: FontFamily.bold,
    backgroundColor: '#EAF2FF',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  summaryHorizontalScroll: {
    flex: 1,
    width: '100%',
  },
  summaryScrollContent: {
    flexGrow: 1,
    minHeight: '100%',
  },
  summaryScrollContentWide: {
    justifyContent: 'center',
  },
  summaryTableWrap: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#E3EAF4',
    borderRadius: 6,
    overflow: 'hidden',
    minWidth: 980,
    width: 980,
    backgroundColor: '#FFFFFF',
  },
  summaryBodyScroll: {
    flex: 1,
    minHeight: 402,
  },
  summaryHeaderWrap: {
    backgroundColor: '#FFFFFF',
  },
  summaryTableWrapWide: {
    width: '100%',
    minWidth: 0,
    maxWidth: 1760,
    alignSelf: 'center',
  },
  summaryHeaderTopRow: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 0,
  },
  summaryHeaderBottomRow: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 2,
    borderBottomColor: '#D7E5F8',
  },
  summaryHeaderPrimaryCell: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    minHeight: 30,
    paddingBottom: 4,
  },
  summaryHeaderGroupCell: {
    flex: 2,
    minWidth: 164,
    justifyContent: 'flex-end',
    alignItems: 'center',
    minHeight: 30,
    paddingBottom: 4,
    borderBottomWidth: 2,
    borderBottomColor: '#D7E5F8',
  },
  summaryHeaderSecondaryCell: {
    flex: 1,
    minWidth: 82,
    minHeight: 32,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRightWidth: 1,
    borderRightColor: '#EEF2F7',
  },
  summaryRegionCell: {
    flex: 2,
    minWidth: 196,
  },
  // Minimal per-column-group tints so High / Medium / Low / Total are visually distinct.
  summaryGroupCellHigh: {
    backgroundColor: '#FDF4F3',
  },
  summaryGroupCellMedium: {
    backgroundColor: '#FFFAF1',
  },
  summaryGroupCellLow: {
    backgroundColor: '#F2F4F8',
  },
  summaryGroupCellTotal: {},
  summaryGroupDivider: {
    borderRightWidth: 1.5,
    borderRightColor: '#D7E0EC',
  },
  summaryHeaderText: {
    fontSize: 12,
    color: '#616161',
    textTransform: 'uppercase',
    letterSpacing: 0.2,
    fontFamily: FontFamily.bold,
  },
  summaryDataRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#EBEFF5',
    backgroundColor: '#FFFFFF',
  },
  summaryAltRow: {},
  summaryHoverRow: {
    backgroundColor: '#C1CAD9',
  },
  summaryGrandTotalRow: {
    backgroundColor: '#F1F5FB',
    borderTopWidth: 1,
    borderTopColor: '#CFDAEA',
    borderBottomWidth: 2,
    borderBottomColor: '#CFDAEA',
  },
  summaryDataCell: {
    flex: 1,
    minWidth: 82,
    minHeight: 44,
    justifyContent: 'center',
    alignItems: 'center',
    borderRightWidth: 1,
    borderRightColor: '#EEF2F7',
    paddingHorizontal: 6,
  },
  summaryDataText: {
    fontSize: 13,
    color: '#2D2D2D',
    fontFamily: FontFamily.regular,
  },
  summaryDataTextStrong: {
    fontFamily: FontFamily.bold,
  },
  execTrendGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
  },
  execTrendCard: {
    flex: 1,
    minWidth: 320,
  },
  trendChartContainer: {
    width: '100%',
  },
  trendChartWrap: {
    width: '100%',
    overflow: 'hidden',
  },
  trendAxisTickText: {
    position: 'absolute',
    fontSize: 10,
    color: '#8B95A7',
  },
  trendAxisPeriodText: {
    position: 'absolute',
    fontSize: 10,
    color: '#8B95A7',
    textAlign: 'center',
  },
  trendPointHitArea: {
    position: 'absolute',
    top: 0,
    width: 28,
    height: 28,
    zIndex: 2,
  },
  trendTooltip: {
    position: 'absolute',
    left: -54,
    alignSelf: 'flex-start',
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRadius: 4,
    backgroundColor: '#1E2127',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 3,
  },
  trendTooltipValue: {
    fontSize: 10,
    fontFamily: FontFamily.bold,
    fontWeight: '700',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  trendTooltipDelta: {
    fontSize: 9,
    fontFamily: FontFamily.regular,
    fontWeight: '600',
    textAlign: 'center',
    marginTop: 2,
  },
  trendTooltipDeltaPositive: {
    color: '#4ADE80',
  },
  trendTooltipDeltaNegative: {
    color: '#F87171',
  },
  chartLegendRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 14,
    rowGap: 8,
    marginTop: 10,
  },
  chartLegendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  chartLegendDot: {
    width: 9,
    height: 9,
    borderRadius: 3,
  },
  chartLegendLineDash: {
    width: 14,
    height: 0,
    borderTopWidth: 2,
    borderStyle: 'dashed',
  },
  chartLegendText: {
    fontSize: 12,
    color: '#4B5563',
    fontFamily: FontFamily.regular,
  },
  barListWrap: {
    rowGap: 10,
    paddingTop: 4,
  },
  maxPotentialBarsContent: {
    width: '100%',
    maxWidth: 760,
    alignSelf: 'center',
  },
  // Lets the chart body center vertically within the card instead of stacking to the top.
  maxPotentialChartBody: {
    flex: 1,
    justifyContent: 'center',
  },
  barHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  barHeaderNameSpacer: {
    width: 126,
    marginRight: 6,
  },
  barHeaderMainText: {
    flex: 1,
    fontSize: 10,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: '#767676',
    fontFamily: FontFamily.bold,
  },
  barHeaderGapText: {
    minWidth: 46,
    textAlign: 'right',
    fontSize: 10,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: '#767676',
    fontFamily: FontFamily.bold,
  },
  barHeaderGapTextCases: {
    minWidth: 76,
  },
  barRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  barRowLabel: {
    width: 126,
    fontSize: 13,
    color: '#1F2937',
    fontFamily: FontFamily.medium,
  },
  barTrack: {
    flex: 1,
    height: 24,
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: '#D7DFEA',
    flexDirection: 'row',
  },
  barActual: {
    height: '100%',
    backgroundColor: '#005CBC',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingRight: 6,
  },
  barActualText: {
    color: '#FFFFFF',
    fontSize: 11,
    fontFamily: FontFamily.bold,
  },
  barGap: {
    height: '100%',
    backgroundColor: '#FF9800',
    justifyContent: 'center',
    alignItems: 'center',
  },
  barGapText: {
    color: '#5A3200',
    fontSize: 11,
    fontFamily: FontFamily.bold,
  },
  barGapValue: {
    minWidth: 46,
    textAlign: 'right',
    fontSize: 12,
    color: '#4B5563',
    fontFamily: FontFamily.bold,
  },
  barGapValueCases: {
    minWidth: 76,
  },
  barLegendWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 16,
    rowGap: 8,
    marginTop: 14,
  },
  barLegendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  barLegendDot: {
    width: 10,
    height: 10,
    borderRadius: 3,
  },
  barLegendText: {
    fontSize: 12,
    color: '#6B7280',
    fontFamily: FontFamily.regular,
  },
  barTooltip: {
    position: 'absolute',
    bottom: 30,
    left: 132,
    backgroundColor: '#1E2127',
    borderRadius: 6,
    paddingHorizontal: 10,
    paddingVertical: 7,
    zIndex: 20,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 6,
    minWidth: 170,
  },
  barTooltipTitle: {
    fontSize: 11,
    fontFamily: FontFamily.bold,
    color: '#FFFFFF',
    marginBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#374151',
    paddingBottom: 2,
  },
  barTooltipRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    marginVertical: 1,
  },
  barTooltipLabelWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  barTooltipDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  barTooltipLabel: {
    fontSize: 10,
    color: '#9CA3AF',
    fontFamily: FontFamily.regular,
  },
  barTooltipValue: {
    fontSize: 10,
    fontFamily: FontFamily.bold,
    color: '#FFFFFF',
  },
});

export default executiveStyles;
